import { useEffect, type FC } from "react";

import Title from "ui/Title/Title";
import Modal from "ui/Modal/Modal";

import CallButton from "./components/CallButton/CallButton";

import styles from "./HelpModal.module.scss";
import WebchatButton from "./components/WebchatButton/WebchatButton";

type Props = {
  onClose: () => void;
  setIsModal: (value: boolean) => void;
};

const HelpModal: FC<Props> = ({ onClose, setIsModal }) => {
  useEffect(() => {
    setIsModal(true);
  }, [setIsModal]);

  const handleClose = () => {
    onClose();
    setIsModal(false);
  };

  return (
    <div className={styles.modal}>
      <Modal onClose={handleClose}>
        <Title className={styles.title}>Как вы хотите связаться?</Title>
        <div className={styles.modalActions}>
          <CallButton />
          <WebchatButton onClick={handleClose} />
        </div>
      </Modal>
    </div>
  );
};

export default HelpModal;
